// Module
var code = "<form name=\"$ctrl.form.formRights\" class=\"panel-body\"> <droit form=\"$ctrl.form.formRights\" ng-disabled=\"$ctrl.kform.options.readOnly || $ctrl.kform.create\" ng-model=\"$ctrl.form\" ng-model-options=\"{ allowInvalid: true }\"></droit> </form> ";
// Exports
export default code;